import * as React from 'react';
import { useField } from 'formik';
import { Checkbox } from '../primitives';
import { cn } from '../../lib/utils';

export interface FormCheckboxProps {
  name: string;
  label?: React.ReactNode;
  id?: string;
  disabled?: boolean;
  className?: string;
}

/** Formik-bound checkbox built on the design-system `Checkbox`. */
export const FormCheckbox: React.FC<FormCheckboxProps> = ({ name, label, id, disabled, className }) => {
  const [field, , helpers] = useField({ name, type: 'checkbox' });
  const inputId = id ?? name;

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Checkbox
        id={inputId}
        checked={!!field.value}
        onCheckedChange={(value) => helpers.setValue(value === true)}
        onBlur={() => helpers.setTouched(true)}
        disabled={disabled}
      />
      {label && (
        <label htmlFor={inputId} className="cursor-pointer select-none text-sm text-foreground">
          {label}
        </label>
      )}
    </div>
  );
};
